import { render, staticRenderFns } from "./kv-image-input.vue?vue&type=template&id=a3000aa4"
import script from "./kv-image-input.vue?vue&type=script&lang=js"
export * from "./kv-image-input.vue?vue&type=script&lang=js"
import style0 from "./kv-image-input.vue?vue&type=style&index=0&id=a3000aa4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports